import React from 'react'
import { PlatformNames } from '@/app/components/Platforms'

// App pricing, allowances and account requirements need a current provider
// record. Repeating a claim elsewhere on this site does not verify it.
const ITEMS = ['iOS and Android', 'Current terms in each store'] as const

export interface AppCtaTrustRowProps {
  /** Tighter type + spacing for the compact hero ribbon. */
  size?: 'sm' | 'md'
  className?: string
}

export default function AppCtaTrustRow({ size = 'md', className = '' }: AppCtaTrustRowProps) {
  const text = size === 'sm' ? 'text-xs' : 'text-sm'
  return (
    <ul
      aria-label="iOS and Android; current terms in each store"
      className={`not-prose flex flex-wrap items-center gap-x-3 gap-y-1 ${text} ${className}`}
    >
      <li className="font-semibold text-ink">
        <PlatformNames />
      </li>
      <li className="inline-flex items-center gap-1 text-gray-500">
        <svg className="h-3.5 w-3.5 text-forest" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            fillRule="evenodd"
            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0l-3.5-3.5a1 1 0 011.4-1.4l2.8 2.79 6.8-6.79a1 1 0 011.4 0z"
            clipRule="evenodd"
          />
        </svg>
        {ITEMS[1]}
      </li>
    </ul>
  )
}

AppCtaTrustRow.displayName = 'AppCtaTrustRow'
